import React from "react";
import { MessageDiv } from "./styles";
import Lottie from "react-lottie";
import { Ptag } from "../../../components/fonts";
import emptyFile from "../../../assets/images/lottie/empty_file.json";

function EmptyFileLottie({ text }) {
  return (
    <MessageDiv style={{ marginRight: 0, marginTop: 0 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: emptyFile,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={120}
          width={120}
          style={{ opacity: "1" }}
          isClickToPauseDisabled
        />
        <Ptag fontSize="18px" fontWeight="600" lineHeight="20">
          {text}
        </Ptag>
      </div>
    </MessageDiv>
  );
}

export default EmptyFileLottie;
